class SellingPlanPicker extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const purchseOptions = this.querySelectorAll('[name="purchase-option"]');
    const sellingPlanSelects = this.querySelectorAll("theme-select.selling-plan-select");
    for (const purchseOption of purchseOptions) {
      purchseOption.addEventListener("input", (event) => {
        if (purchseOption.value == "subscription") {
          const sellingPlan = this.querySelector(`[selling-plan="${purchseOption.id}"] [name="current-selling-plan"]`);
          if (!!sellingPlan) {
            this.setSellingPlan(sellingPlan.value);
          }
        }
        if (purchseOption.value == "onetime") {
          this.removeSellingPlan();
        }
      });
    }
    for (const sellingPlanSelect of sellingPlanSelects) {
      sellingPlanSelect.addEventListener("change", (event) => {
        const sellingPlan = sellingPlanSelect.value;
        if (!!sellingPlan) {
          this.setSellingPlan(sellingPlan);
        }
      });
    }
  }
  updateDOM(newURL, sellingPlanId) {
    const that = this;
    const sectionId = that.dataset.sectionId;
    that.classList.remove("loading");
    fetch(newURL, {
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      method: "GET",
    })
      .then((response) => response.text())
      .then((data) => {
        let template = document.createElement("template");
        template.innerHTML = data.trim();
        const newPDP = template.content;
        const oldPDP = document.querySelector(`#shopify-section-${sectionId}`);
        const oldAddToCartInfos = document.querySelectorAll(`#shopify-section-${sectionId} .product-meta-add-to-cart .product-variant-price`);
        const newAddToCartInfos = template.content.querySelectorAll(`.product-meta-add-to-cart .product-variant-price`);
        const oldAddToCartButtons = document.querySelectorAll(`#shopify-section-${sectionId} .product-meta-add-to-cart .add-to-cart-button`);
        const newAddToCartButtons = template.content.querySelectorAll(`.product-meta-add-to-cart .add-to-cart-button`);
        if (oldAddToCartInfos.length === newAddToCartInfos.length) {
          oldAddToCartInfos.forEach((newInfo, index) => {
            newInfo.replaceWith(newAddToCartInfos[index]);
          })
        }
        if (oldAddToCartButtons.length === newAddToCartButtons.length) {
          oldAddToCartButtons.forEach((oldButton, index) => {
            oldButton.replaceWith(newAddToCartButtons[index]);
          })
        }
        const selectorsToUpdate = [
          ".product-block-type-sellingplans",
          ".product-block-type-price",
          ".product-block-type-benefits",
        ];
        selectorsToUpdate.forEach((selector) => {
          const newElement = newPDP.querySelector(selector);
          const oldElement = oldPDP.querySelector(selector);
          if (!!newElement && !!oldElement) {
            oldElement.replaceWith(newElement);
          }
        });
        window.dispatchEvent(
          new CustomEvent("sellingplan:changed", { bubbles: true, cancelable: false, detail: sellingPlanId }),
        );
        that.classList.remove("loading");
      })
      .catch(function (err) {
        that.classList.remove("loading");
        console.error(err);
      });
  }
  updateURL(variantId, sellingPlanId) {
    const params = new URL(document.location).searchParams;
    if (!!variantId) {
      params.set("variant", variantId);
    } else {
      params.delete("variant");
    }
    if (!!sellingPlanId) {
      params.set("selling_plan", sellingPlanId);
    } else {
      params.delete("selling_plan");
    }
    let newUrl = new URL(document.location);
    newUrl.search = params.toString();
    let newHistoryState = newUrl.href.split("/").pop();
    history.replaceState(null, "", newHistoryState);
  }
  setSellingPlan(sellingPlanId) {
    const form = this.closest("form.shopify-product-form");
    const current_variant_input = form.querySelector('input[name="id"]');
    const variantId = current_variant_input.value;
    this.updateURL(variantId, sellingPlanId);

    const sectionId = this.dataset.sectionId;
    const productUrl = this.dataset.productUrl;
    const newURL = `${productUrl}?variant=${variantId}&selling_plan=${sellingPlanId}&section_id=${sectionId}`;
    this.updateDOM(newURL, sellingPlanId);
  }
  removeSellingPlan() {
    const form = this.closest("form.shopify-product-form");
    const current_variant_input = form.querySelector('input[name="id"]');
    const variantId = current_variant_input.value;
    this.updateURL(variantId, null);

    const sectionId = this.dataset.sectionId;
    const productUrl = this.dataset.productUrl;
    const newURL = `${productUrl}?variant=${variantId}&section_id=${sectionId}`;
    this.updateDOM(newURL, null);
  }
}
if(!customElements.get("selling-plan-picker")) {
  customElements.define("selling-plan-picker", SellingPlanPicker);
}

class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const optionValues = this.querySelectorAll("input.product-option-value");
    for (const optionValue of optionValues) {
      optionValue.addEventListener("input", (event) => {
        this.setVariant(optionValue.value);
      });
    }
  }
  updateDOM(newURL, variantId) {
    const that = this;
    const sectionId = that.dataset.sectionId;
    const dynamicId = that.closest(".shopify-section")?.id;
    that.classList.add("loading");
    fetch(newURL, {
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        // replace product_main
        const template = document.createElement("template");
        template.innerHTML = data[sectionId].trim();
        const oldKlaviyoPopup = document.querySelector(`#shopify-section-${sectionId} .klaviyo-popup-wrapper`);
        const newKlaviyoPopup = template.content.querySelector(`.klaviyo-popup-wrapper`);
        const oldBlocks = document.querySelectorAll(`#shopify-section-${sectionId} .product-meta-block`);
        const newBlocks = template.content.querySelectorAll(".product-meta-block");
        const oldProductMedia = document.querySelector(`#shopify-section-${sectionId} .product-media-wrapper`);
        const newProductMedia = template.content.querySelector(`.product-media-wrapper`);
        const oldAddToCartInfos = document.querySelectorAll(`#shopify-section-${sectionId} .product-meta-add-to-cart .product-variant-price`);
        const newAddToCartInfos = template.content.querySelectorAll(`.product-meta-add-to-cart .product-variant-price`);
        const oldAddToCartButtons = document.querySelectorAll(`#shopify-section-${sectionId} .product-meta-add-to-cart .add-to-cart-button`);
        const newAddToCartButtons = template.content.querySelectorAll(`.product-meta-add-to-cart .add-to-cart-button`);
        const oldStockMessage = document.querySelector(`#shopify-section-${sectionId} .product-meta-add-to-cart .stock-message-wrapper`);
        const newStockMessage = template.content.querySelector(`.product-meta-add-to-cart .stock-message-wrapper`);

        if (!!oldStockMessage && !!newStockMessage) {
          oldStockMessage.replaceWith(newStockMessage);
        }
        if (!!oldKlaviyoPopup && !!newKlaviyoPopup) {
          oldKlaviyoPopup.replaceWith(newKlaviyoPopup);
        }
        if (!!oldProductMedia && !!newProductMedia) {
          oldProductMedia.replaceWith(newProductMedia);
        }
        if (oldAddToCartInfos.length === newAddToCartInfos.length) {
          oldAddToCartInfos.forEach((newInfo, index) => {
            newInfo.replaceWith(newAddToCartInfos[index]);
          })
        }
        if (oldAddToCartButtons.length === newAddToCartButtons.length) {
          oldAddToCartButtons.forEach((oldButton, index) => {
            oldButton.replaceWith(newAddToCartButtons[index]);
          })
        }
        for (let i = 0; i < oldBlocks.length; i++) {
          const newElement = newBlocks[i];
          const oldElement = oldBlocks[i];
          if (!!newElement && !!oldElement && !oldElement.classList.contains("product-block-type-additional_payments") && !oldElement.classList.contains("product-block-type-app") && !oldElement.classList.contains("product-block-type-add_to_cart")) {
            oldElement.replaceWith(newElement);
          }
        }

        if(this.hasAttribute("external")){
          const newVariantPicker = template.content.querySelector(`variant-picker`);
          const oldVariantPicker = document.querySelector(`#${dynamicId} variant-picker`);
          const newProductPicker = template.content.querySelector(`product-picker`);
          const oldProductPicker = document.querySelector(`#${dynamicId} product-picker`);
          const newPriceWrapper = template.content.querySelector('.product-price-wrapper');
          const oldPriceWrapper = document.querySelector(`#${dynamicId} .product-price-wrapper`);
          const newProductOptionLabel = template.content.querySelector('.option-value-name');
          const oldProductOptionLabel = document.querySelector(`#${dynamicId} .option-value-name`);
          if(!!newVariantPicker && !!oldVariantPicker){
            oldVariantPicker.replaceWith(newVariantPicker);
          }
          if(!!newProductPicker && !!oldProductPicker){
            oldProductPicker.replaceWith(newProductPicker);
          }
          if(!!newPriceWrapper && !!oldPriceWrapper){
            oldPriceWrapper.replaceWith(newPriceWrapper);
          }
          if(!!newProductOptionLabel && !!oldProductOptionLabel){
            if(!document.body.contains(oldProductOptionLabel)) {
              const optionValueNameWrapper = document.querySelector(`#${dynamicId} .option-value-name-wrapper`);
              if(!!optionValueNameWrapper){
                optionValueNameWrapper.appendChild(newProductOptionLabel);
              } else {
                console.log('Option value name wrapper not found');
              }
            } else {
              oldProductOptionLabel.replaceWith(newProductOptionLabel);
            }
          }
        }

        window.dispatchEvent(
          new CustomEvent("variant:changed", { bubbles: true, cancelable: false, detail: variantId }),
        );
        // replace product description
        const product_description_section = document.querySelector('section.shopify-section-product-description');
        if(!!product_description_section){
          template.innerHTML = data[product_description_section.id.split('shopify-section-').pop()].trim();
          if(!!product_description_section && !!template.content.firstChild){
            product_description_section.replaceWith(template.content.firstChild);
          }
        }

        // replace ingredients
        const product_tabs_section = document.querySelector('section.shopify-section-product-tabs')
        if(!!product_tabs_section){

          template.innerHTML = data[product_tabs_section.id.split('shopify-section-').pop()].trim();
          const ingredients_old = product_tabs_section.querySelector('.tab_wrapper.tab-ingredients');
          const ingredients_new = template.content.querySelector('.tab_wrapper.tab-ingredients');
          if(!!ingredients_old && !!ingredients_new){
            const ingredients_old_content = ingredients_old.querySelector('.tab_content');
            const ingredients_new_content = ingredients_new.querySelector('.tab_content');
            ingredients_old_content.replaceWith(ingredients_new_content);
            ingredients_old.querySelector('.tab_content_wrapper').removeAttribute('style');
            ingredients_old.classList.remove('open');
            ingredients_old.classList.add('close');
          }
        }

        // replace product-tabs-v2 content
        const product_tabs_v2_section = document.querySelector('section.shopify-section-product-tabs-v2');
        if (!!product_tabs_v2_section) {
          const tabDrawerV2Id = product_tabs_v2_section.id.split('shopify-section-').pop();
          const tabDrawerV2El = product_tabs_v2_section.querySelector('tab-drawer-v2');
          if (data[tabDrawerV2Id] && tabDrawerV2El?.refreshFromHTML) {
            tabDrawerV2El.refreshFromHTML(data[tabDrawerV2Id]);
          }
        }

        that.classList.remove("loading");
      })
      .catch(function (err) {
        that.classList.remove("loading");
        console.error(err);
      });
  }
  updateURL(variantId, sellingPlanId) {
    const params = new URL(document.location).searchParams;
    if (!!variantId) {
      params.set("variant", variantId);
    } else {
      params.delete("variant");
    }
    if (!!sellingPlanId) {
      params.set("selling_plan", sellingPlanId);
    } else {
      params.delete("selling_plan");
    }
    let newUrl = new URL(document.location);
    newUrl.search = params.toString();
    history.replaceState(null, "", newUrl.href);
  }
  setVariant(variantId) {
    const form = this.closest("form.shopify-product-form");
    const current_selling_plan_input = form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = current_selling_plan_input.value;
    if (!this.hasAttribute("external")){
      this.updateURL(variantId, sellingPlanId);
    }

    const sectionId = this.dataset.sectionId;
    const productUrl = this.dataset.productUrl;
    const product_description_id = document.querySelector('section.shopify-section-product-description')?.getAttribute('id')?.split('shopify-section-')?.pop();
    const product_tabs_id = document.querySelector('section.shopify-section-product-tabs')?.getAttribute('id')?.split('shopify-section-')?.pop();
    const product_tabs_v2_id = document.querySelector('section.shopify-section-product-tabs-v2')?.getAttribute('id')?.split('shopify-section-')?.pop();
    const newURL = `${productUrl}?variant=${variantId}&selling_plan=${sellingPlanId}&sections=${sectionId}${product_description_id ? ','+product_description_id : ''}${product_tabs_id ? ','+product_tabs_id : ''}${product_tabs_v2_id ? ','+product_tabs_v2_id : ''}`;
    this.updateDOM(newURL, variantId);
  }
}
if(!customElements.get("variant-picker")){
  customElements.define("variant-picker", VariantPicker);
}

let customBuiltInElementsSupported = false;
class AtcButton extends HTMLButtonElement {
  constructor() {
    super();
    customBuiltInElementsSupported = true;
  }
  addToCart(form) {
    const that = this;
    const formData = new FormData(form);
    // const sectionId = formData.get('section-id');
    formData.append("sections", "cart-drawer");
    that.classList.add("loading");
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.status) {
          const error_string = `\nCART GET FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
          throw new Error(error_string, { cause: "Cart Error" });
        } else {
          that.classList.remove("loading");
          window.dispatchEvent(
            new CustomEvent("cart:add", {
              detail: {
                ...response,
                add_type: 'single',
                added_count: Number(formData.get("quantity")) || 1,
              },
            }),
          );
        }
      })
      .catch((error) => {
        that.classList.remove("loading");
        console.error(error);
      });
  }
  connectedCallback() {
    const that = this;
    const form = that.closest("form");
    if (!!form) {
      that.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const disabled = that.hasAttribute("disabled") && that.getAttribute("disabled") !== "false";
        if (!disabled) {
          that.addToCart(form);
        }
      });
    }
  }
}
if(!customElements.get("atc-button")) {
  customElements.define("atc-button", AtcButton, { extends: "button" });
}

/* Start - Polyfill for Safari */
if (!customBuiltInElementsSupported) {
  function replaceUnsupportedElements() {
    let atcButtons = document.querySelectorAll('button[is="atc-button"]');
    for (const atcButton of atcButtons) {
      const newAtcButton = document.createElement("add-to-cart");
      if (atcButton.hasAttribute("disabled")) {
        newAtcButton.setAttribute("disabled", atcButton.getAttribute("disabled"));
      }
      newAtcButton.setAttribute("class", atcButton.getAttribute("class"));
      newAtcButton.innerHTML = atcButton.innerHTML;
      atcButton.replaceWith(newAtcButton);
    }
  }
  document.addEventListener("DOMContentLoaded", replaceUnsupportedElements);
  window.addEventListener("variant:changed", replaceUnsupportedElements);
  window.addEventListener("product:changed", replaceUnsupportedElements);
  window.addEventListener("sellingplan:changed", replaceUnsupportedElements);
}
/* End - Polyfill for Safari */
class ProductMedia extends HTMLElement {
  constructor() {
    super();
  }
  scrollLeft() {
    const navigationWidth = this.navigation.getBoundingClientRect().width;
    if (this.navigation.scrollLeft > 0) {
      const newScrollState = Math.max(
        0,
        Math.round((this.navigation.scrollLeft - navigationWidth + Number.EPSILON) * 2) / 2,
      );
      this.navigation.scrollLeft = newScrollState;
    }
  }
  scrollRight() {
    const navigationWidth = this.navigation.getBoundingClientRect().width;
    const navigationChildrenCount = this.navigationChildren.length;
    const childrenWidth = this.navigationChildren.reduce((total, acc) => total + acc.getBoundingClientRect().width, 0);
    const maxScrollRight = Math.round(childrenWidth - navigationWidth);
    if (this.navigation.scrollLeft < maxScrollRight) {
      const newScrollState = Math.round((this.navigation.scrollLeft + navigationWidth + Number.EPSILON) * 2) / 2;
      this.navigation.scrollLeft = newScrollState;
    }
  }
  toggleButtonVisibility() {
    const navigationWidth = this.navigation.getBoundingClientRect().width;
    const childrenWidth = this.navigationChildren.reduce((total, acc) => total + acc.getBoundingClientRect().width, 0);
    const maxScrollRight = Math.floor(childrenWidth - navigationWidth);
    if (this.navigation.scrollLeft <= 0) {
      this.scrollLeftButton.classList.add("hidden");
    } else {
      this.scrollLeftButton.classList.remove("hidden");
    }
    if (this.navigation.scrollLeft >= maxScrollRight) {
      this.scrollRightButton.classList.add("hidden");
    } else {
      this.scrollRightButton.classList.remove("hidden");
    }
  }
  setActiveItem(item, items) {
    if(!!item){
      for (const other_item of items) {
        other_item.classList.remove("active");
      }
      item.classList.add("active");
      this.dataset.mainMediaId = item.dataset.mediaId;
    }
  }
  setSliderEventListener() {
    this.slider.embla.on('select', (embla) => {
      const currentIndex = embla.selectedScrollSnap();
      const currentItem = this.querySelector(`.product-media-item[data-index="${currentIndex}"]`);
      const currentItemBoundingBox = currentItem.getBoundingClientRect();
      if(currentItemBoundingBox.right > window.innerWidth){
        this.scrollRight();
      }
      else if(currentItemBoundingBox.left < 0) {
        this.scrollLeft();
      }
      this.setActiveItem(currentItem, this.items);
    });
  }
  setMaxImageWidth() {
    if(window.innerWidth > 1024){
      const product_section = this.closest('.shopify-section-product-main');
      if(!!product_section){
        const selling_plan_block = product_section.querySelector('.product-block-type-sellingplans');
        if(!!selling_plan_block){
          const selling_plans_hidden = selling_plan_block.querySelector('selling-plan-picker.hide-block');
          let product_blocks_height = product_section.querySelector('.product-meta-blocks');
          if(!!product_blocks_height){
            product_blocks_height = product_blocks_height.getBoundingClientRect().height + 40;
          } else {
            product_blocks_height = 40;
          }
          const product_main_image = this.querySelector('.main-media');
          if(!selling_plans_hidden){
            const selling_plan_block_height = !!selling_plan_block ? selling_plan_block.getBoundingClientRect().height : 0;
            let selling_plan_block_max_height = 0;
            selling_plan_block.querySelectorAll('.purchase_option-button').forEach(component => selling_plan_block_max_height += component.getBoundingClientRect().height);
            selling_plan_block.querySelectorAll('.tooltip-container').forEach(component => selling_plan_block_max_height += component.getBoundingClientRect().height);
            selling_plan_block_max_height += 157;
            product_main_image.style.setProperty('--max-width', (product_blocks_height - selling_plan_block_height + selling_plan_block_max_height)+'px');
          } else {
            product_main_image.style.setProperty('--max-width', product_blocks_height+'px');
          }
        }
      }
    }
  }
  connectedCallback() {
    this.items = this.querySelectorAll(".product-media-item");
    this.slider = this.querySelector("clever-slider");
    this.navigation = this.querySelector(".product-media-nav");
    this.navigationChildren = Array.from(this.navigation.querySelectorAll(".product-media-item")).filter(
      (item) => getComputedStyle(item, null).display !== "none",
    );
    this.scrollLeftButton = this.querySelector(".scroll-left");
    this.scrollRightButton = this.querySelector(".scroll-right");
    for (const item of this.items) {
      item.addEventListener("click", (event) => {
        this.setActiveItem(item, this.items);

        const index = Number(item.dataset.index);
        if(index != null){
          this.slider.embla.scrollTo(index);
        }
      });
    }

    if(!!this.slider.embla){
      this.setSliderEventListener();
    }else{
      this.slider.addEventListener('init', () => {
        this.setSliderEventListener();
      });
    }

    if (!!this.scrollLeftButton && !!this.scrollRightButton) {
      this.scrollLeftButton.addEventListener("click", this.scrollLeft.bind(this));
      this.scrollRightButton.addEventListener("click", this.scrollRight.bind(this));
      this.navigation.addEventListener("scroll", this.toggleButtonVisibility.bind(this));
    }
    this.setMaxImageWidth();
    window.addEventListener('resize', this.setMaxImageWidth.bind(this));
  }
}
if(!customElements.get("product-media")) {
  customElements.define("product-media", ProductMedia);
}

class KlaviyoNotifyPopup extends HTMLElement {
  constructor() {
    super();
  }
  open() {
    this.classList.add("active");
  }
  close() {
    this.classList.remove("active");
  }
  successCallback(result) {
    const content = this.querySelector(".klaviyo-content");
    const success = this.querySelector(".klaviyo-success");
    content.classList.add("hidden");
    success.classList.remove("hidden");
  }
  errorCallback(error) {
    const content = this.querySelector(".klaviyo-content");
    const error_display = this.querySelector(".klaviyo-error");
    content.classList.add("hidden");
    error_display.classList.remove("hidden");
  }
  submit(email, variant) {
    const that = this;
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: `${email}`,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variant}`,
            },
          },
        },
      },
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-06-15",
      },
      body: JSON.stringify(payload),
    };
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Q2xsJy", options)
      .then((result) => that.successCallback(result))
      .catch((error) => that.errorCallback(error));
  }
  connectedCallback() {
    this.variantId = !!this.getAttribute("variant") ? this.getAttribute("variant") : null;
    this.emailInput = this.querySelector("#klaviyo-email-input");
    this.submitButton = this.querySelector(".klaviyo-email-submit");
    this.closeButton = this.querySelector(".klaviyo-close");
    this.content = this.querySelector(".klaviyo-popup-card");
    this.addEventListener("click", (event) => {
      if (!this.content.contains(event.target)) {
        this.close();
      }
    });
    if (!!this.closeButton) {
      this.closeButton.addEventListener("click", (event) => {
        this.close();
      });
    }
    if (!!this.emailInput && !!this.submitButton && !!this.variantId) {
      this.submitButton.addEventListener("click", (event) => {
        if (this.emailInput.validity.valid) {
          const email = this.emailInput.value;
          const variant = this.variantId;
          if (!!email) {
            this.submit(email, variant);
          }
        } else {
          alert("Email invalid");
        }
      });
    }
  }
}
if(!customElements.get("klaviyo-notify-popup")) {
  customElements.define("klaviyo-notify-popup", KlaviyoNotifyPopup);
}

class KlaviyoNotifyButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const popup_id = !!this.getAttribute("for") ? this.getAttribute("for") : null;
    this.popup = document.querySelector(`#${popup_id}`);
    this.addEventListener("click", (event) => {
      this.popup.open();
    });
  }
}
if(!customElements.get("klaviyo-notify-button")) {
  customElements.define("klaviyo-notify-button", KlaviyoNotifyButton);
}

class StickyAddToCartTrigger extends HTMLElement {
  constructor() {
    super();
  }
  updateStickyAddToCart() {
    const zendeskWidget = document.querySelector('iframe#launcher'); // find better selector
    if(document.querySelectorAll('#zendesk_style_tag').length == 0 && zendeskWidget){
      const style_tag = document.createElement('style');
      const head = document.querySelector('head');
      if(head && style_tag){
        style_tag.id = 'zendesk_style_tag'
        head.appendChild(style_tag);
      }
    }
    const triggerPosition = this.getBoundingClientRect();
    const triggerNotInView = triggerPosition.bottom < 0 || (triggerPosition.top > window.innerHeight && window.innerWidth < 1024);
    if (triggerNotInView) {
      this.addToCartWrapperElement.classList.add("active");
      if(zendeskWidget && document.querySelector('#zendesk_style_tag').length != 0){
        const style = `iframe#launcher{ bottom: ${this.addToCartWrapperElement.offsetHeight + 3}px !important}`
        document.querySelector('#zendesk_style_tag').textContent = style;
      }
    } else {
      this.addToCartWrapperElement.classList.remove("active");
      if(zendeskWidget && document.querySelector('#zendesk_style_tag').length != 0){
        document.querySelector('#zendesk_style_tag').textContent = '';
      }
    }
  }
  connectedCallback() {
    const that = this;
    that.addToCartWrapperElement = document.querySelector("[sticky-add-to-cart-wrapper]");
    if (!that.addToCartWrapperElement) {
      document.addEventListener("DOMContentLoaded", (event) => {
        that.addToCartWrapperElement = document.querySelector("[sticky-add-to-cart-wrapper]");
        that.updateStickyAddToCart();
      });
    } else {
      that.updateStickyAddToCart();
    }
    window.addEventListener("scroll", that.updateStickyAddToCart.bind(that));
    window.addEventListener("resize", that.updateStickyAddToCart.bind(that));
  }
}
if(!customElements.get("sticky-add-to-cart-trigger")) {
  customElements.define("sticky-add-to-cart-trigger", StickyAddToCartTrigger);
}

class GiftCardProperties extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const textarea = this.querySelector("#gift-card-description");
    const textarea_counter = this.querySelector(".input-counter-textarea [data-counter]");
    if (!!textarea && !!textarea_counter) {
      textarea_counter.dataset.counter = textarea.value.length;
      textarea.addEventListener("input", () => {
        textarea_counter.dataset.counter = textarea.value.length;
      });
    }
    const design_select = this.querySelector("#gift-card-design");
    const product_media = document.querySelector("product-media");
    if (!!design_select && !!product_media) {
      design_select.addEventListener("change", () => {
        const active_option_title = design_select.querySelector("option[selected]")?.innerHTML;
        const active_option_name = design_select.querySelector("option[selected]")?.dataset.designName;
        if (!!active_option_title) {
          const activeImageId = product_media.querySelector(`[alt="${active_option_title}"]`)?.closest("[data-media-id]")?.dataset.mediaId;
          const items = product_media.querySelectorAll(".product-media-item");
          const item = product_media.querySelector(`[data-media-id="${activeImageId}"][data-index]`);
          if (!!item) {
            product_media.setActiveItem(item, items);
            const index = Number(item.dataset.index);
            if(index != null){
              product_media.slider.embla.scrollTo(index);
            }
          }
        }
        if (!!active_option_name) {
          const design_name = document.querySelector("#gift-card-design-name");
          design_name.value = active_option_name;
        }
      });
    }
  }
}
if(!customElements.get("gift-card-properties")) {
  customElements.define("gift-card-properties", GiftCardProperties);
}

class HtmlTruncate extends HTMLElement {
  constructor() {
    super();
  }
  getWordCount(string){
    return Array.from(string.split(/\s+/).filter(Boolean)).length;
  }
  getSplitIndex(string, words) {
    let previousCharLetter = false;
    let wordCount = 0;
    let index = 0;
    for(const char of string) {
      if(/\s/.test(char)){
        if (previousCharLetter) {
          wordCount++;
        }
        previousCharLetter = false;
      } else {
        previousCharLetter = true;
      }
      if(wordCount >= words) {
        return index;
      }
      index++;
    }
  }
  setUnviolable(node) {
    node.unviolable = true;
    if(node !== this) {
      this.setUnviolable(node.parentNode);
    }
  }
  traverseNodeTree(node) {
    const traverseNodeTree = this.traverseNodeTree.bind(this);
    node.childNodes.forEach(traverseNodeTree);
    if(this.wordCount < this.maxWordCount) {
      if(node.nodeType === Node.TEXT_NODE) {
        const count = this.getWordCount(node.textContent);
        if((this.wordCount + count) > this.maxWordCount) {
          const remainingWords = this.maxWordCount - this.wordCount;
          const splitIndex = this.getSplitIndex(node.textContent, remainingWords);
          node.splitText(splitIndex);
          node.textContent += '...';
        }
        if((this.wordCount + count) == this.maxWordCount) {
          node.textContent += '...';
        }
        this.wordCount += count;
      }
      this.setUnviolable(node);
    }
  }
  pruneNodeTree(node) {
    const pruneNodeTree = this.pruneNodeTree.bind(this);
    node.childNodes.forEach(pruneNodeTree);
    if(!node.unviolable) {
      this.nodesToRemove[this.nodesToRemove.length] = node;
    }
  }
  showLess() {
    this.show_more_button.dataset.state = 'more';
    this.removeAttribute('open');
    let height = this.full_description.getBoundingClientRect().height;
    this.description_wrapper.style.height = height+'px';
    requestAnimationFrame(() => {
      height = this.truncated_description.getBoundingClientRect().height;
      this.description_wrapper.style.height = height+'px';
      setTimeout(() => {
        this.truncated_description.classList.add('active');
        this.full_description.classList.remove('active');
        this.description_wrapper.removeAttribute('style')
      }, 300);
    });
  }
  showMore() {
    this.show_more_button.dataset.state = 'less';
    this.setAttribute('open', '');
    let height = this.truncated_description.getBoundingClientRect().height;
    this.description_wrapper.style.height = height+'px';
    this.full_description.classList.add('active');
    this.truncated_description.classList.remove('active');
    requestAnimationFrame(() => {
      height = this.full_description.getBoundingClientRect().height;
      this.description_wrapper.style.height = height+'px';
      setTimeout(() => {
        this.description_wrapper.removeAttribute('style')
      }, 300);
    });
  }
  init() {
    this.description_wrapper = this.querySelector('.description-wrapper');
    this.full_description = this.querySelector('.full-description');
    this.truncated_description = this.querySelector('.truncated-description');
    this.show_more_button = this.querySelector('.show-more-button');
    this.wordCount = 0;
    this.maxWordCount = Number(this.getAttribute('words'));
    this.nodesToRemove = [];
    this.traverseNodeTree(this.truncated_description);
    if(this.wordCount >= this.maxWordCount) {
      this.pruneNodeTree(this.truncated_description);
      this.nodesToRemove.forEach(node => node.remove());
      this.full_description.classList.remove('active');
      this.truncated_description.classList.add('active');
      this.show_more_button.classList.add('active');
    } else {
      this.full_description.classList.add('active');
      this.truncated_description.classList.remove('active');
      this.show_more_button.classList.remove('active');
    }
    this.show_more_button.addEventListener('click', event => {
      if(this.hasAttribute('open')) {
        this.showLess();
      } else {
        this.showMore();
      }
    });
  }
  connectedCallback() {
    this.init();
  }
}
if(!customElements.get("html-truncate")) {
  customElements.define("html-truncate", HtmlTruncate);
}

class BreadcrumbsCollection extends HTMLElement {
  connectedCallback() {
    // Check if a collection is stored in sessionStorage
    const prodID = this.dataset.productId;
    const data = sessionStorage.getItem(`product_${prodID}_collection`);
    if (!data) return; // no collection, keep default content
    // If there is a collection, update the breadcrumbs
    const collection = JSON.parse(data);
    const breadcrumbLink = this.querySelector('.breadcrumbs__link');
    if (breadcrumbLink) {
      breadcrumbLink.textContent = collection.title;
      breadcrumbLink.href = collection.url;
    }
    sessionStorage.removeItem(`product_${prodID}_collection`);
  }
}
if (!customElements.get('breadcrumbs-collection')) {
  customElements.define('breadcrumbs-collection', BreadcrumbsCollection);
}